import React, {useState} from 'react'
import './TopNav.scss'
import {withRouter} from 'react-router-dom';
import {MDBModal, MDBModalBody} from "mdbreact";
import CashDetail from "../../pages/UserWallet/CashDetail";
import AddMoney from "../../pages/UserWallet/AddMoney";
import WithdrawMoney from "../../pages/UserWallet/WithdrawMoney";
import {connect} from "react-redux";
import {assetUrl} from "../../serviceApi";
import Login from "../../pages/Login/Login";

const search = assetUrl+'images/icon_blackSearch.svg'
const WalletIcon = assetUrl+"images/wallet.svg";
const NotificationIcon = assetUrl+"images/notification-icon.svg";
const NotificationIconEmpty = assetUrl+"images/Notifications-bell-empty-black.svg";

const TopNav = (props) => {
	const [currentModal, setCurrentModal] = useState("");
	const [login_modal, setLoginModal] = useState(false);

	const notification = []
	const nav = " navbar-"

	const setActiveModal = (args) => {
		setCurrentModal(args)
	}

	const checkUserLoggedIn = (action) => {
		if(props.logged_in === false){
			openLoginModal();
		} else if(action === "wallet") {
			setCurrentModal("cash");
		} else if(action === "notification") {
			props.history.push("/notification")
		}
	}
	const openLoginModal = () => {
		setLoginModal(true);
	}
	const closeLoginModal = () => {
		setLoginModal(false);
	}
	const completeLogin = () => {
		closeLoginModal();
		window.location.reload();
		// this.getWalletData();
	}

	return (
		<>
			<div className={"top-nav-component"}>
				<div className={nav + "main d-flex justify-content-between align-items-center"}>
					<img src={search} alt={'search'} className={nav + "icon"}
						 onClick={() => props.history.push("/all-stocks")}/>
					<p className={nav + "logo"} onClick={() => props.history.push("/home")}>NETA</p>
					<div className={nav + "d-flex"}>
						<img src={WalletIcon} alt={'wallet'} className={nav + "icon"}
							 onClick={() => checkUserLoggedIn("wallet")}/>
						<img src={notification.length > 0 ? NotificationIcon : NotificationIconEmpty} alt={'notify'}
							 className={nav + "icon bell-icon"}
							 // onClick={() => props.history.push("/notification")}
							 onClick={() => checkUserLoggedIn("notification")}
						/>
					</div>
				</div>
				<MDBModal fullHeight={false} position="bottom" overflowScroll={true} inline={false}
						  noClickableBodyWithoutBackdrop={false} isOpen={currentModal !== ""}>
					<MDBModalBody>
						{
							currentModal === "add" ?
								<AddMoney
									setActiveModal={(args) => setActiveModal(args)}
									user_details={props.user_details}
								/> :
								currentModal === "withdraw" ?
									<WithdrawMoney
										setActiveModal={(args) => setActiveModal(args)}
										user_details={props.user_details}
									/> :
									currentModal === "cash" ?
										<CashDetail setActiveModal={(args) => {
											setActiveModal(args)
										}}/> :
										null
						}

					</MDBModalBody>
				</MDBModal>
			</div>
			<Login isOpen={login_modal}
				   closeModal={closeLoginModal}
				   completeLogin={completeLogin}
			/>
			</>

	)
}
const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details,
	logged_in: state.UserReducer.logged_in
});

export default connect(mapStateToProps)(withRouter(TopNav))
